import { baseUrl } from "../../../../boot";
import axios from "axios";

//  employee login
export const empLogin = async (data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}adminuser/api/v1/login-emp`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// Employee Otp Sent
export const sentEmpOtp = async (data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}adminuser/api/v1/send-emp-otp`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// Verify Employee Otp
export const verifyEmpOtp = async (data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}adminuser/api/v1/verify-emp-otp`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// Change Employee Password
export const changePassword = async (data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}adminuser/api/v1/change-password-emp`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// Change Employee Password
export const empLogout = async (data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}adminuser/api/v1/logout-emp`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// Change Employee Password
export const authTokenVerify = async (data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}adminuser/api/v1/verify-token`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
// Change Employee Password
export const refreshToken = async (data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}adminuser/api/v1/refresh-token`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// Change Employee Password
export const sentInvite = async (data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}adminuser/api/v1/emp-invitation-emails`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}